import { Box } from "@mui/material";
import styled from "styled-components";
import { HeaderNavigationItemContainer } from "../HeaderNavigation/HeaderNavigationItem/HeaderNavigationItem.styled";

export const DrawerMenu = styled(Box)`
  & > ${HeaderNavigationItemContainer}:first-of-type {
    margin-top: 60px;
  }
`;
